import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Divider, Flex, Row, Space } from "antd";
import { BaseContainer } from "components/containers";
import { DataGrid, FillButton } from "components/elements";
import { BaseSection, TitleLayout } from "components/layouts";
import { closeBranchDetailListData } from "data/branch/branch-close";
import { URL_ADMIN, URL_ADMIN_BRANCH, URL_BRANCH_CLOSING_REPORT_CLOSE } from 'routes/AdminRoute'
import { getBranchClosingReportDetail } from "api/branch";

export default function HqBranchCloseReportPerformance () {
  const navigate = useNavigate()
  // const [searchParams, setSearchParams] = useSearchParams();

  const columnName = ['FRCS1', 'FRCS2', 'FRCT1', 'FRCT2', 'CTCC1', 'CTCC2', 'CTCC3', 'NESC1', 'NESC2', 'NESC3', 'SCMN1', 'SCMN2', 'SCMN3', 'SCMN4', 'SCMN5', 'SCMN6', 'CSMN1', 'CSMN2', 'CSMN3', 'COSM', 'ONMK1', 'ONMK2', 'ONMK3', 'ONMK4', 'ONMK5', 'ONMK6', 'ONMK7', 'ONMK8', 'ONMK9', 'ONMK10', 'ONMK11', 'ONMK12', 'ONMK13', 'ONMK14', 'ONMK15', 'ONMK16', 'ONMK17', 'OFMK1', 'OFMK2', 'OFMK3', 'MNME1', 'MNME2', 'MNME3', 'MNME4', 'MNME5', 'ETC'];
  const [data, setData] = useState(closeBranchDetailListData);
  const { state } = useLocation();
  const { branchIdx, year, month, reportIdx } = state;
  const yyyymm = year + month
  const [values, setValues] = useState({
    yyyymm: Number(yyyymm),
    branch_idx: branchIdx,
    frcs1: '', // 상담건수
    frcs2: '', // 계약가능상담자
    frct1: '', // 계약건
    frct2: '', // 교육원
    ctcc1: '', // 해지건
    ctcc2: '', // 교육원
    ctcc3: '', // 해지사유
    nesc1: '', // 가맹교육대상
    nesc2: '', // 정착교육 대상
    nesc3: '', // 정착교육 관리 내용
    scmn1: '', // 방문횟수
    scmn2: '', // 운영팀 방문요청 교육원
    scmn3: '', // 요청 사유
    scmn4: '', // 문제교육원
    scmn5: '', // 문제사항
    scmn6: '', // 관리방안
    csmn1: '', // 정기상담 관리를 위한 활동
    csmn2: '', // 가정통신문 미발송 교육원
    csmn3: '', // 미발송 사유
    cosm: '', // 홍보,광고비용 합계
    onmk1: '', // 맘카페 횟수/비용
    onmk2: '', // 맘카페 url_1
    onmk3: '', // 맘카페 url_2
    onmk4: '', // 맘카페 url_3
    onmk5: '', // 맘카페 url_4
    onmk6: '', // 공식카페 창업횟수
    onmk7: '', // 공식카페 입회횟수
    onmk8: '', // 블로그 창업횟수
    onmk9: '', // 블로그 입회횟수
    onmk10: '', // 블로그 기타내용
    onmk11: '', // 인스타그램 광고여부
    onmk12: '', // 인스타그램 창업횟수
    onmk13: '', // 인스타그램 입회횟수
    onmk14: '', // 인스타그램 기타내용 횟수
    onmk15: '', // 기타 횟수/비용
    onmk16: '', // 기타 url
    onmk17: '', // 기타 홍보내용
    ofmk1: '', // 오프라인 횟수/비용
    ofmk2: '', // 오프라인 활동내용
    ofmk3: '', // 오프라인 활동사진
    mnme1: '', // 월간회의 관리교육원
    mnme2: '', // 월간회의 참석교육원
    mnme3: '', // 월간회의 불참교육원 & 사유
    mnme4: '', // 월간회의 회의내용
    mnme5: '', // 월간회의 학원강사스터디
    etc: '' // 건의사항 아이디어
  })


  const renderColumn = (value, record, idx, month) => {
    let price = value;

    // 총 가격 계산 함수
    const calculateTotalPrice = (data, idx) => {
      let calculatedPrice = 0;
      
      if (2 === month) {
        // 'mon' 값에 따른 계산
        calculatedPrice = Number(values.onmk1) + Number(values.onmk11) + Number(values.onmk15) + Number(values.ofmk1);
      } else {
        for (let i = idx; i < data.length; i++) {
          if (['21', '31', '35', '38'].includes(data[i].key)) {
            calculatedPrice += Number(data[i][`mon${2}`]);
          }
        }
      }
      return calculatedPrice;
    };

    if (record?.key == 'cosm' && month < state?.month) {
      price = calculateTotalPrice(data, idx);
      const total = new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW' }).format(price);
      return <>{total}</>;
    }
    
    const won = new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW' }).format(price);
    
    return (
      <>
        {
          month <= state.month ? (
            <>
              {
                idx == '19' || idx == '20' || idx == '30' || idx == '34' || idx == '37'?  // 금액
                (
                  <>{won}</>
                ) : (
                  <>
                    {
                      (idx== '21' || idx == '22' || idx=='23' || idx=='24' || idx == '35') && value ?
                      (
                        <>
                          <span
                            onClick={() => window.open(value, "_blank")}
                            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                          >
                            url 이동
                          </span>
                        </>
                      ) : (
                        <>
                          {record?.key !== '20' && typeof value === 'string' && <>{value}</>}
                        </>
                      )
                    }
                  </>
                )
              }
              </>
          ) : (
            <></>
          )
        }
      </>
    )
  }

  const columns = [
    {
      title: '구분',
      align: 'center',
      dataIndex: 'col1',
      colSpan: 3,
      width: '6%',
      render: (value, record, idx) => {
        let rowSpan = 1;
        let colSpan = 1;
        if (value && value !== '') {
          for (let i=idx+1; i<data?.length; i++) {
            if (data[i].col1 === '' || !data[i].col1) {
              rowSpan++;
            } else {
              break;
            }
          }
        } else {
          rowSpan=0;
        }
        if ((value === '홍보,고비용 합계' || record.key === '19') || (value === '건의사항 & 아이디어' || record.key === '45')) {
          colSpan=3
        }
        return {
          children: <>{value}</>,
          props: {
            rowSpan: rowSpan,
            colSpan: colSpan
          }
        }
      }
    }, {
      title: '',
      align: 'center',
      dataIndex: 'col2',
      colSpan: 0,
      width: '5%',
      render: (value, record, idx) => {
        let rowSpan = 1;
        let colSpan = 2;
        if (value && value !== '') {
          for (let i=idx+1; i<data?.length; i++) {
            if (data[i].col2 === '' || !data[i].col2) {
              rowSpan++;
            } else {
              break;
            }
          }
        } else {
          rowSpan=0;
        }

        if (record.col3 && record.col3 !== '') {
          colSpan = 1;
        } else if ((value === '홍보,고비용 합계' || record.key === '19') || (value === '건의사항 & 아이디어' || record.key === '45')) {
          colSpan=0;
        }
        
        if (idx+1 < data?.length) {
          if ((data[idx+1].key === '19' || data[idx+1].col1 === '홍보,광고비용 합계') || (data[idx+1].key === '45' || data[idx+1].col1 === '건의사항 & 아이디어')) {
            rowSpan = 1;
          }
        }

        return {
          children: <>{value}</>,
          props: {
            rowSpan: rowSpan,
            colSpan: colSpan,
          }
        }
      }
    }, {
      title: <span className="qwer"></span>,
      align: 'center',
      dataIndex: 'col3',
      colSpan: 0,
      width: '5%',
      render: (value, record, idx) => {
        let colSpan = 0;
        if (value && value!== '') {
          colSpan=1;
        }

        return {
          children: <>{value}</>,
          props: {
            colSpan: colSpan
          }
        }
      }
    }, {
      title: '1월',
      align: 'center',
      dataIndex: 'mon1',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '1')
      }
    }, {
      title: '2월',
      align: 'center',
      dataIndex: 'mon2',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '2')
      }
    }, {
      title: '3월',
      align: 'center',
      dataIndex: 'mon3',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '3')
      }
    }, {
      title: '4월',
      align: 'center',
      dataIndex: 'mon4',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '4')
      }
    }, {
      title: '5월',
      align: 'center',
      dataIndex: 'mon5',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '5')
      }
    }, {
      title: '6월',
      align: 'center',
      dataIndex: 'mon6',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '6')
      }
    }, {
      title: '7월',
      align: 'center',
      dataIndex: 'mon7',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '7')
      }
    }, {
      title: '8월',
      align: 'center',
      dataIndex: 'mon8',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '8')
      }
    }, {
      title: '9월',
      align: 'center',
      dataIndex: 'mon9',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '9')
      }
    }, {
      title: '10월',
      align: 'center',
      dataIndex: 'mon10',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '10')
      }
    }, {
      title: '11월',
      align: 'center',
      dataIndex: 'mon11',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '11')
      }
    }, {
      title: '12월',
      align: 'center',
      dataIndex: 'mon12',
      width: '7%',
      render: (value, record, idx) => {
        return renderColumn(value, record, idx, '12')
      }
    }, 
  ]

  const toCloseDetail = () => {
    navigate(`${URL_ADMIN+URL_ADMIN_BRANCH+URL_BRANCH_CLOSING_REPORT_CLOSE}?mon=${month}`, { state: { branchIdx: branchIdx, year: year, month: month, reportIdx: reportIdx } })
  }

  const fnGetDetail = async () => {
    const params = {
      yyyymm: yyyymm,
      branchIdx: branchIdx,
      reportIdx: reportIdx
    }
    console.log(params)

    getBranchClosingReportDetail(params)
    .then((res) => {
      console.log(res)
      const dataList = res?.data?.data_list;
      const dataInfo = res?.data?.data_info;
      console.log(dataList)
      
      setData((prevData) => 
        prevData.map((item, idx) => {
          return {
            ...item,
            mon1: dataList[0][columnName[idx]],
            mon2: dataList[1][columnName[idx]],
            mon3: dataList[2][columnName[idx]],
            mon4: dataList[3][columnName[idx]],
            mon5: dataList[4][columnName[idx]],
            mon6: dataList[5][columnName[idx]],
            mon7: dataList[6][columnName[idx]],
            mon8: dataList[7][columnName[idx]],
            mon9: dataList[8][columnName[idx]],
            mon10: dataList[9][columnName[idx]],
            mon11: dataList[10][columnName[idx]],
            mon12: dataList[11][columnName[idx]],
          }
        })
      )

      setValues((prevValues) => {
        const currentData = dataList[Number(month) -1];
        return {
          ...prevValues,
          ...currentData
        }
      })

    })
  }

  useEffect(() => {
    fnGetDetail();
  }, [])
  
  return (<BaseSection>
      <BaseContainer>
        <Flex justify={'space-between'}>
          <TitleLayout>인천지사 실적관리 보고서</TitleLayout>
          <Space>
            <FillButton label="실적관리보고서" backgroundColor={'var(--color-blue01)'} />
            <FillButton label="마감보고서" color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={toCloseDetail} />
          </Space>
        </Flex>
        <Divider className="divider" />
        <DataGrid 
          rowKey={'key'}
          bordered
          data={data}
          columns={columns}
        />
        <Divider className="divider"/>
        <Row>
          <Col span={11}/>
          <Col span={13}>
            <FillButton label="다음 페이지" backgroundColor={'var(--color-blue01)'} onClick={toCloseDetail} />
          </Col>
        </Row>
      </BaseContainer>
    </BaseSection>
  )
}